<script>
import sidemenu from './sidemenu'
import { routeStartsWith } from '@/helpers/routes'
import { mapGetters, mapActions } from 'vuex'
import bus from '@/utils/eventBus'
import { isMobile } from 'mobile-device-detect'

const myBody = document.getElementsByTagName('body')[0]

export default {
  name: 'sidebar',
  data () {
    return {
      isActive: false,
      mobileOpen: false,
      mobile: isMobile
    }
  },
  components: {
    sidemenu
  },
  methods: {
    ...mapActions(['logout']),
    openMenuMobile (active) {
      if (!active) {
        this.mobileOpen = true
        bus.$emit('open-menu-mobile', {show: true})
      }
      if (active) {
        this.mobileOpen = false
        bus.$emit('open-menu-mobile', {show: false})
      }
    },
    addBodyClass (active) {
      if (!active) {
        this.isActive = true
        myBody.classList.add('menu_sm')
      }
      if (active) {
        this.isActive = false
        myBody.classList.remove('menu_sm')
      }
    },
    hiddenMenu () {
      bus.$emit('hidden-mobile-menu', {status: false})
    },
    doLogout () {
      const currentUser = { ...this.user }
      const isProfessional = (user) => {
        return user.type === 'professional'
      }

      const isCompany = (user) => {
        return user.type === 'company'
      }

      this.logout()
        .then(() => {
          if (isProfessional(currentUser)) {
            return this.$router.push({name: 'auth.professional.login'})
          }

          if (isCompany(currentUser)) {
            return this.$router.push({name: 'auth.company.login'})
          }

          window.location.href = '/'
        })
    }
  },
  mounted () {
    /** Fechando menu mobile apos selecionar no menu  */
    bus.$on('siderbar-open-menu-mobile', values => {
      this.mobileOpen = values.show
    })
  },
  destroyed () {

  },
  computed: {
    ...mapGetters(['user', 'userIsProfessional']),
    routeIsSettings () {
      return routeStartsWith(this.$route, 'settings.profile.')
    },
    routeIsPatient () {
      return routeStartsWith(this.$route, 'patient.')
    },
    routeIsPatientSettingsDependents () {
      return routeStartsWith(this.$route, 'settings.dependents.')
    },
    routeIsPatientSettingsCovenants () {
      return routeStartsWith(this.$route, 'settings.covenants.')
    },
    routeIsPatientSettingsAddresses () {
      return routeStartsWith(this.$route, 'settings.addresses.')
    },
    routeIsPatientSettingsConfig () {
      return routeStartsWith(this.$route, 'settings.config.')
    }
  }
}
</script>

<template lang="pug">
  aside#minileftbar.minileftbar
    ul.menu_list
      li
        a.bars(
          v-if="mobile",
          href='javascript:void(0);',
          style="display: inline;",
          @click.prevent="openMenuMobile(!(!mobileOpen))")
        a.navbar-brand(href='index.html')
          img(src='/static/images/logo.svg', alt='logo')
      //-li
        a.btn_overlay.hidden-sm-down(href='javascript:void(0);')
          i.zmdi.zmdi-search
      li
        a.menu-sm.cursor-pointer(@click.prevent="addBodyClass(!(!isActive))")
          i.zmdi.zmdi-swap
      //-li.menuapp-btn
        a(href='javascript:void(0);')
          i.zmdi.zmdi-apps
      li.notifications.badgebit
        a(href='javascript:void(0);')
          i.zmdi.zmdi-notifications
          .notify
            span.heartbit
            span.point
      //-li.task.badgebit
        a(href='javascript:void(0);')
          i.zmdi.zmdi-flag
          .notify
            span.heartbit
            span.point
      li
        router-link.menu-toggle(:to="{ name: 'tenant.profile.schedules.me'}")
          i.zmdi.zmdi-calendar

      //-li
        a(href='mail-inbox.html', title='Inbox')
          i.zmdi.zmdi-email
      li
        router-link.menu-toggle(:to="{ name: 'tenant.common-area.index'}")
          i.zmdi.zmdi-store
      li
         router-link.menu-toggle(:to="{ name: 'tenant.files.index'}")
          i.zmdi.zmdi-attachment-alt
      li
         router-link.menu-toggle(:to="{ name: 'tenant.access.index'}")
          i.zmdi.zmdi-walk
      li
         router-link.menu-toggle(:to="{ name: 'dweller.livings.index'}")
          i.zmdi.zmdi-accounts-add

      //-li
        a.fullscreen(href='javascript:void(0);', data-provide='fullscreen')
          i.zmdi.zmdi-fullscreen
      li.power
        a.js-right-sidebar(href='javascript:void(0);')
          i.zmdi.zmdi-settings.zmdi-hc-spin
        a.mega-menu.cursor-pointer(@click.prevent='doLogout()')
          i.zmdi.zmdi-power

</template>
<style scoped>
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/layout/sidebar-tenant.vue